import { Controller } from "@hotwired/stimulus"

// Debounced auto-submit of the enclosing form as the user types.
export default class extends Controller {
  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), 300)
  }
}
